import { render, staticRenderFns } from "./ctlQuoteItemTemplateForm.vue?vue&type=template&id=3192511f&scoped=true&"
import script from "./ctlQuoteItemTemplateForm.vue?vue&type=script&lang=js&"
export * from "./ctlQuoteItemTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./ctlQuoteItemTemplateForm.vue?vue&type=style&index=0&id=3192511f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192511f",
  null
  
)

component.options.__file = "ctlQuoteItemTemplateForm.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VDataTable,
  VIcon,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
